import 'css-chunksrc/client/common/resourceAllocationMenu/resourceTags/styles.scss';export default {
  "header": "_header_w4niy_1",
  "icon": "_icon_w4niy_10",
  "title": "_title_w4niy_18",
  "list": "_list_w4niy_25"
};